import { PortModelAlignment } from '@projectstorm/react-diagrams';
import NodeTypes from '../../NodeTypes';
import DefaultNodeModel, { DefaultNodeModelOptions } from '../defaultNode/DefaultNodeModel';
import { PortModel } from '../../ports/PortModel';

export interface BotMessageModelOptions extends DefaultNodeModelOptions {
}

export class BotMessageModelData {
	messages: Array<string> = [];
}

export default class BotMessageNodeModel extends DefaultNodeModel {
	data: BotMessageModelData = new BotMessageModelData();

	constructor(options: BotMessageModelOptions = {}) {
	  super({
	    ...options,
	    type: NodeTypes.botMessageNode,
	  });
	  // setup an in and out port
	  this.addPort(
	    new PortModel({
				in: true,
	      name: 'in',
	      alignment: PortModelAlignment.BOTTOM,
	    }),
	  );
	  this.addPort(
	    new PortModel({
				in: false,
	      name: 'out',
	      alignment: PortModelAlignment.TOP,
	    }),
	  );
	}

	public setTitle(title: string) {
	  this.title = title;
	}

	serialize() {
	  return {
	    ...super.serialize(),
	  };
	}

	deserialize(event:any): void {
	  super.deserialize(event);
	}
}
